import { get, isNumber, map } from 'lodash';
import { setMedications } from './actions';
import MedicationsService from './MedicationsService';
import { currentPatientIdSelector } from '../patient';

// HELPERS
const toMedicationRequest = (
  {
    activeNumerator,
    activeNumeratorUnit,
    alternateName,
    customName,
    notes,
    datePrescribed,
    dosage,
    frequency,
    frequencyUnit,
    fdaMedication,
    id,
    prescribingDoctorId,
    pharmacyId,
    prn,
    recurrenceId,
    routeId,
    type,
  },
  patientId,
) => ({
  activeNumerator,
  activeNumeratorUnit,
  alternateName,
  customName,
  notes,
  datePrescribed,
  dosage,
  frequency,
  frequencyUnit,
  id,
  fdaMedicationId: get(fdaMedication, 'id'),
  patientId,
  pharmacyId,
  prescribingDoctorId,
  prn,
  recurrenceId,
  routeId: isNumber(routeId) ? routeId : null,
  type,
});

const toRequest = (medications, patientId) => ({
  prescriptions: map(medications, medication =>
    toMedicationRequest(medication, patientId),
  ),
  patientId,
});

// THUNKS
export const saveMedicationsAsync = medications => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(
    MedicationsService.create(toRequest(medications, patientId)),
  ).then(() => dispatch(setMedications(medications)));
};

export const fetchMedicationsAsync = () => (dispatch, getState) => {
  const state = getState();
  const patientId = currentPatientIdSelector(state);

  return dispatch(MedicationsService.getByPatientId(patientId)).then(
    medications => {
      return dispatch(setMedications(medications));
    },
  );
};

export const searchFdaMedicationsAsync = (searchText, page) => dispatch => {
  if (!searchText) return Promise.resolve([]);
  return dispatch(MedicationsService.search(searchText, page));
};



// WEBPACK FOOTER //
// ./src/lib/dataLayer/medications/thunks.js